import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

const TIMEOUT = 50000;

function isContentTypeJson(response) {
    const contentType = response.headers['content-type'];
    return contentType && contentType.indexOf('application/json') !== -1;
}

function parseError(response) {
    const error = new Error('Error while calling Api');

    if (isContentTypeJson(response)) {
        return response.error;
    }

    return {
        ...error,
        status: response.status,
    };
}

function getAbsoluteUrl(url) {
    let a;
    if (!a) a = document.createElement('a');
    a.href = url;
    return a.href;
}

function parseJSON(response) {
    if (response == null) {
        return null;
    }
    return response;
}

axios.interceptors.response.use((response) => {
    if (isContentTypeJson(response)) {
        return response;
    }
    throw parseError(response);
// eslint-disable-next-line consistent-return
}, (error) => {
    if (error && error.response && error.response.status) {
        switch (error.response.status) {
        case 401:
            return error.response;
        case 400:
            return error.response;
        case 404:
            return error.response;
        default:
            return Promise.reject(error);
        }
    } else {
        return Promise.reject(error);
    }
});

function callAxios(url, options) {
    const aUrl = url.toString().startsWith('http') ? url : getAbsoluteUrl(url).replace(':3002', ':4000');
    const aOptions = options || {};
    aOptions.credentials = 'include';

    return axios({ url: aUrl, ...aOptions, timeout: (aOptions.timeout || 50000) })
        .then(parseJSON);
}

function commonHeaders() {
    const reqId = uuidv4();
    return {
        Accept: 'application/json',
        CorrelationId: reqId,
    };
}

class axiosClient {
    static get(url) {
        const options = {
            method: 'GET',
            headers: {
                ...commonHeaders(),
            },
            timeout: TIMEOUT,
        };
        return callAxios(url, options);
    }
}

export default axiosClient;
